export default (whatsapp, nome, telefone, itens, formaPagto, entrega, endereco, troco, valorEntrega, idPedido) => {
    var stringItem = ''
    const quebraLinha = '%0A'
    var total = 0
    const _valorEntrega = Number(valorEntrega)

    itens.map((item) => {
        var vlTotalUn = parseFloat(item.valorTotal).toFixed(2).toString().replace('.', ',')
        total += item.valorTotal
        stringItem += `*${item.quantidade}* un. *${item.descricao.replace('&', 'E')}* ${quebraLinha}Cód.: ${item.codigo} - R$ *${vlTotalUn}*${quebraLinha}`
        item.extras.map((extra) => {
            var preco = parseFloat(extra.preco).toFixed(2).toString().replace('.', ',')
            stringItem += `  ↳ *${item.quantidade}* un. *${extra.descricao}* R$ *${preco}* UN ${quebraLinha}`
        })

        if(item.skuSelecionado){
            if(item.skuSelecionado.cor) stringItem += `Cor: *${item.skuSelecionado.cor}*${quebraLinha}`
            if(item.skuSelecionado.tamanho) stringItem += `Tamanho: *${item.skuSelecionado.tamanho}*${quebraLinha}`
            if(item.skuSelecionado.voltagem) stringItem += `Voltagem: *${item.skuSelecionado.voltagem}*${quebraLinha}`
            if(item.skuSelecionado.sabor) stringItem += `Sabor: *${item.skuSelecionado.sabor}*${quebraLinha}`   
        }

        stringItem += `${quebraLinha}`
    })

    if(entrega) total += _valorEntrega

    const urlBase = 'https://api.whatsapp.com/send?phone=+55'
    const url = `${urlBase}${whatsapp}&text=`
    const strPedido = `*Pedido* ${quebraLinha}Olá, meu nome é: *${nome}*,${quebraLinha}${quebraLinha}Meu pedido é:${quebraLinha}`
    const strItens = `${stringItem}`
    const strFormaEntrega = entrega ? `O pedido será para *entrega*${quebraLinha}` : `O pedido será para *retirada*${quebraLinha}`
    const strEndereco = `Endereço: *${endereco}* ${quebraLinha}`
    const strFormaPagamento = `A forma de pagamento será: *${formaPagto}*${quebraLinha}`
    const strContato = `Meu telefone para contato é: *${telefone}*${quebraLinha}`
    const strTotalPedido = `O total do meu pedido é de: R$ *${total.toFixed(2).toString().replace('.', ',')}*`
    const strTroco = `Troco para: *${troco}*${quebraLinha}`
    const strIdPedido = `ID Pedido: *${idPedido}*${quebraLinha}`
    const strValorEntrega = _valorEntrega > 0 ? `Valor da entrega: R$ *${_valorEntrega.toFixed(2).toString().replace('.',',')}*${quebraLinha}` : ''

    if(entrega == "entrega" || entrega == "Entrega" || entrega == "Entregar"){
        if(formaPagto == 'Dinheiro' && troco != '')
            return `${url}${strPedido}${strItens}${strFormaEntrega}${strEndereco}${strValorEntrega}${strFormaPagamento}${strTroco}${strContato}${strIdPedido}${strTotalPedido}`
        return `${url}${strPedido}${strItens}${strFormaEntrega}${strEndereco}${strValorEntrega}${strFormaPagamento}${strContato}${strIdPedido}${strTotalPedido}`
    }
    if(formaPagto == 'Dinheiro' && troco != '')
        return `${url}${strPedido}${strItens}${strFormaEntrega}${strFormaPagamento}${strTroco}${strContato}${strIdPedido}${strTotalPedido}`
    
        return `${url}${strPedido}${strItens}${strFormaEntrega}${strFormaPagamento}${strContato}${strIdPedido}${strTotalPedido}`

}